import { useRef, useState } from "react";
import "./Contact.css";

export default function Contact() {
  const form = useRef();
  
  // Form state
  const [formData, setFormData] = useState({
    user_name: '',
    user_email: '',
    message: ''
  });
  
  // Validation and UI state
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(''); // 'success' or 'error'

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Validation functions
  const validateForm = () => {
    const newErrors = {};
    
    // Name validation
    if (!formData.user_name.trim()) {
      newErrors.user_name = 'Name is required';
    } else if (formData.user_name.trim().length < 2) {
      newErrors.user_name = 'Name must be at least 2 characters';
    }
    
    // Email validation
    if (!formData.user_email.trim()) {
      newErrors.user_email = 'Email is required';
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.user_email)) {
        newErrors.user_email = 'Please enter a valid email address';
      }
    }
    
    // Message validation
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setSubmitStatus('');
    
    // Validate form
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/send-email`, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //     "Authorization": `Bearer ${process.env.REACT_APP_CONTACT_FORM_TOKEN}`,
      //   },
      //   body: JSON.stringify(formData),
      // });

      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${process.env.REACT_APP_CONTACT_FORM_TOKEN}`,
        },
        body: JSON.stringify(formData),
      });


      const result = await response.json();

      if (result.success) {
        setSubmitStatus("success");
        setFormData({ user_name: "", user_email: "", message: "" });
        setErrors({});
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-container">
      {/* Tile Grid */}
      <div className="tiles-rectangle">
        <a
          href="https://leetcode.com/u/Sahil-7/"
          target="_blank"
          rel="noreferrer"
          className="tile horizontal"
        >
          <img src="/leetcode.png" alt="LeetCode" />
        </a>
        <a
          href="https://www.linkedin.com/in/sahil-mandavkar/"
          target="_blank"
          rel="noreferrer"
          className="tile tall"
        >
          <img src="/linkedin.png" alt="LinkedIn" />
        </a>
        <a
          href="https://github.com/sahill3"
          target="_blank"
          rel="noreferrer"
          className="tile horizontal"
        >
          <img src="/github.png" alt="GitHub" />
        </a>
      </div>

      <div className="contact-form">
        <h1>Send me a message</h1>
        
        {/* Status Messages */}
        {submitStatus === 'success' && (
          <div className="status-message success">
            Message sent successfully! I'll get back to you soon.
          </div>
        )}
        {submitStatus === 'error' && (
          <div className="status-message error">
            Failed to send message. The service is currently unavailable.
          </div>
        )}
        
        <form ref={form} onSubmit={sendEmail}>
          <div className="form-field">
            <input 
              type="text" 
              name="user_name" 
              placeholder="Your Name" 
              value={formData.user_name}
              onChange={handleInputChange}
              className={errors.user_name ? 'error' : ''}
            />
            {errors.user_name && <span className="error-message">{errors.user_name}</span>}
          </div>
          
          <div className="form-field">
            <input 
              type="email" 
              name="user_email" 
              placeholder="Your Email" 
              value={formData.user_email}
              onChange={handleInputChange}
              className={errors.user_email ? 'error' : ''}
            />
            {errors.user_email && <span className="error-message">{errors.user_email}</span>}
          </div>
          
          <div className="form-field">
            <textarea 
              name="message" 
              placeholder="Your Message" 
              value={formData.message}
              onChange={handleInputChange}
              className={errors.message ? 'error' : ''}
            ></textarea>
            {errors.message && <span className="error-message">{errors.message}</span>}
          </div>
          
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Send Email'}
          </button>
        </form>
      </div>
    </div>
  );
}
